import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Help = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M6.5 7.917C6.5 4.915 8.952 2.5 12 2.5s5.5 2.415 5.5 5.417c0 2.154-1.358 3.329-2.717 4.243C13.392 13.106 12 14.28 12 16.5V18'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 21.5'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.5 7.917C5.5 4.35 8.414 1.5 12 1.5s6.5 2.849 6.5 6.417c0 2.685-1.745 4.121-3.156 5.071C13.996 13.905 13 14.818 13 16.5V18a1 1 0 1 1-2 0v-1.5c0-2.755 1.786-4.192 3.22-5.167l.005-.003c1.305-.878 2.275-1.792 2.275-3.413C16.5 5.482 14.51 3.5 12 3.5S7.5 5.481 7.5 7.917a1 1 0 1 1-2 0'
          fill='currentColor'
        />
        <path
          d='M12 21.5'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    )}
  </IconBase>
);
